import { Description } from '@repo/ui';

const TimeOutContent = () => {
  return (
    <div className="flex flex-1 items-center justify-center container-medium">
      <Description
        graphic={
          <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/iconography/icg_exclamation-mark-dimmed_sm.svg`} className={'w-[88px]'} alt={''} />
        }
        title={'동의 가능한\n유효 시간이 지났어요'}
        description={'비즈넵 환급을 이용해주셔서 감사합니다.'}
      />
    </div>
  );
};

export default TimeOutContent;
